module.exports = __webpack_public_path__ + "static/media/3.Auto Switches.c004526d.webp";